var DS3_FormHelpers = new Object();

DS3_FormHelpers.version = "1.0.3";

DS3_FormHelpers.getSubmitBtn = function ($form) {
	return $form.find(".hs_submit.hs-submit input.submit-btn");
};

DS3_FormHelpers.getConsentField = function ($form) {
	const $el = $form.find('.legal-consent-container .hs-input[type="checkbox"]');

	return $el;
};

DS3_FormHelpers.getDemoTypeField = function ($form) {
	const $el = $form.find(
		'.field.hs-form-field.hs_requested_demo_type .hs-input[name="requested_demo_type"]',
	);

	return $el;
};

DS3_FormHelpers.getDemoTypeCheckedField = function ($form) {
	const $el = $form.find(
		'.field.hs-form-field.hs_requested_demo_type .hs-input[name="requested_demo_type"]:checked',
	);

	return $el;
};

DS3_FormHelpers.preventFormSubmit = function ($form) {
	const $submitBtn = this.getSubmitBtn($form);

	$submitBtn.prop("disabled", true);

	// console.log('DS3.preventFormSubmit', $submitBtn);

	return;
};

DS3_FormHelpers.redirectToDemoVideo = function (access) {
	if (access) {
		helpers.Cookie.set("demoVideoAccessGranted", "1");
	}
	const redirectLink =
		window.location.origin + "/video-demo/" + window.location.search;
	location.href = redirectLink;

	if (helpers.shouldDebug("ds3"))
		console.log("[DS3.FormHelpers] redirectToDemoVideo", redirectLink);

	return;
};

DS3_FormHelpers.setAdditionalRequiredFields = function ($form) {
	var _parent = DS3;
	if (!_parent.$el[0].hasAttribute("data-required")) return;

	const additionalRequiredFields = _parent.$el[0].getAttribute("data-required");
	const additionalRequiredFieldsArray = additionalRequiredFields.split(",");
	const showRequiredFieldError = ($field) => {
		$field.addClass("invalid error");
		const $errorBlock = $field.closest(".input").next(".hs-error-msgs");

		const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list custom-error" role="alert">
        <li><label class="hs-error-msg hs-main-font-element">  Please complete this required field.</label>
        </li>
      </ul>
    `;

		if ($errorBlock.length <= 0) {
			$field.closest(".input").after(errorHTML);
		} else {
			$errorBlock.html(errorHTML);
		}
	};

	const clearRequiredFieldError = ($field) => {
		$field.removeClass("invalid error");
		$field.closest(".input").next(".custom-error").remove();
	};

	additionalRequiredFieldsArray.map((v, i) => {
		const $field = $form.find(`.hs-input[name="${v}"]`);
		$field.attr("required", true).on("blur input focus", () => {
			if (!$field.val()) {
				if (helpers.shouldDebug("ds3"))
					console.log("[DS3.FormHelpers] additonalRequiredField is empty");
				showRequiredFieldError($field);
			} else {
				clearRequiredFieldError($field);
			}
		});
	});
};

DS3_FormHelpers.getAdditionalRequiredFields = function ($form) {
	var _parent = DS3;
	if (!_parent.$el[0].hasAttribute("data-required")) return;

	const additionalRequiredFields = _parent.$el[0].getAttribute("data-required");
	const additionalRequiredFieldsArray = additionalRequiredFields.split(",");

	var arf = [];

	additionalRequiredFieldsArray.map((v, i) => {
		$form.find(`.hs-input[name="${v}"]`).attr("required", true);

		arf.push($form.find(`.hs-input[name="${v}"]`));
	});

	return arf;
};

DS3_FormHelpers.setFieldLabelVisibilty = function ($form) {
	const inputFields = $form.find(
		".hs-form-field:not(.hs-fieldtype-booleancheckbox):not(.hs-fieldtype-radio)",
	);
	inputFields.each(function () {
		let input = $(this).find(".hs-input");
		if (input.val()) {
			$(this).addClass("show-field-label");
		}

		// Show/hide label on focus & blur events
		input
			.focus(function () {
				$(this).closest(".hs-form-field").addClass("show-field-label");
			})
			.blur(function () {
				if (!this.value) {
					$(this).closest(".hs-form-field").removeClass("show-field-label");
				}
			});
	});
};

DS3_FormHelpers.field_company = function ($form) {
	const $company = $form.find('input[name="company"]');
	$company.attr("placeholder", "Business Name");
};

DS3_FormHelpers.field_email = function ($form) {
	const $email = $form.find('input[name="email"]');
	$email.attr("placeholder", "Email Address");
};

DS3_FormHelpers.field_name = function ($form) {
	const $nameField = $form.find('input[name="full_name"]');
	const $firstName = $form.find('input[name="firstname"]');
	const $lastName = $form.find('input[name="lastname"]');
	const errorMsg = `
    <ul class="no-list hs-error-msgs inputs-list" role="alert">
      <li>
        <label class="hs-error-msg hs-main-font-element">Please ensure you enter a first and last name with more than 2 letters and no special characters.
        </label>
      </li>
    </ul>
  `;
	const nameRegex =
		/^([a-zA-Z.]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)$/;

	if ($nameField.attr("type") === "hidden") {
		$firstName.on("input blur", function () {
			if (helpers.shouldDebug("ds3"))
				console.log("[DS3.FormHelpers] firstName:", $firstName.val());
			$nameField.val($firstName.val() + " " + $lastName.val());
			if (helpers.shouldDebug("ds3"))
				console.log("[DS3.FormHelpers] nameField:", $nameField.val());
		});
		$lastName.on("input blur", function () {
			if (helpers.shouldDebug("ds3"))
				console.log("[DS3.FormHelpers] lastName:", $lastName.val());
			$nameField.val($firstName.val() + " " + $lastName.val());
			if (helpers.shouldDebug("ds3"))
				console.log("[DS3.FormHelpers] nameField:", $nameField.val());
		});
	} else {
		$nameField.on("input blur", function () {
			const val = $(this).val().trim();

			if (!nameRegex.test(val)) {
				$nameField.addClass("invalid error");

				const $errorBlock = $nameField.closest(".input").next(".hs-error-msgs");
				if ($errorBlock.length <= 0) {
					$nameField.closest(".input").after(errorMsg);
				} else {
					$errorBlock.html($(errorMsg).html());
				}
			} else {
				$nameField.removeClass("invalid error");
				$nameField.closest(".input").next(".hs-error-msgs").remove();
			}

			const parts = val.split(/\s+/);
			$firstName.val(parts[0] || "");
			$lastName.val(parts.slice(1).join(" ") || "");
		});
	}
};

DS3_FormHelpers.field_industry = function ($form) {
	// Setup Industry Fields Fns
	if ($form.find('input[name="industry"]').length > 0) {
		$form.find('input[name="industry"]').closest(".hs-form-field").hide();
		$form
			.find('select[name="industry_select"]')
			.closest(".input")
			.siblings("label")
			.append('<span class="hs-form-required">*</span>');
		$form.find('select[name="industry_select"]').change(function () {
			$form.find('input[name="industry"]').val($(this).val());
			if ($(this).val() === "Other") {
				$form
					.find('input[name="industry"]')
					.closest(".hs-form-field")
					.slideDown(200);
			} else {
				$form
					.find('input[name="industry"]')
					.closest(".hs-form-field")
					.slideUp(200);
			}
		});
	} else {
		$form
			.find('select[name="industry_select"]')
			.closest(".hs-form-field")
			.hide();
	}
};

DS3_FormHelpers.fields_utms = function ($form) {
	// Shortcode utms are PAGE DEFAULTS — applied first so explicit URL
	// params can override them below (same precedence as HSForm). Positional:
	// [source, medium, campaign, term, content], empty slot = not pinned.
	var _parent = DS3;
	var $parentEl = _parent.$el;
	const shortcode_utms = $parentEl.data("utms")
		? $parentEl.data("utms").split(",")
		: false;
	if (shortcode_utms) {
		shortcode_utms.map((utm, i) => {
			const utm_names = [
				"utm_source",
				"utm_medium",
				"utm_campaign",
				"utm_term",
				"utm_content",
			];
			if (utm !== "") {
				$form.find(`input[name="${utm_names[i]}"]`).val(utm);
			}
		});
	}

	// URL params WIN over the shortcode defaults — partner links must
	// attribute correctly no matter what the page pins.
	const urlParams = new URLSearchParams(window.location.search);
	const url_utms = {
		utm_source: urlParams.get("utm_source"),
		utm_medium: urlParams.get("utm_medium"),
		utm_campaign: urlParams.get("utm_campaign"),
		utm_term: urlParams.get("utm_term"),
		utm_content: urlParams.get("utm_content"),
	};

	Object.entries(url_utms).forEach(([key, value]) => {
		if (value !== null) {
			$form.find(`input[name="${key}"]`).val(value);
		}
	});

	// Check if utm_medium is empty
	if ($form.find('input[name="utm_medium"]').val() === "") {
		if (helpers.shouldDebug("ds3"))
			console.info("[DS3.FormHelpers] set default utm_medium");
		$form.find('input[name="utm_medium"]').val("website");
	}

	const impactId = urlParams.get("irclickid");
	if (impactId) {
		$form.find('input[name="impact_id"]').val(impactId);
	}

	$form.find('input[name^="utm_"]').each(function () {
		if (helpers.shouldDebug("ds3"))
			console.log(
				`[DS3.FormHelpers] ${$(this).attr("name")}: ${$(this).val()}`,
			);
	});
};

DS3_FormHelpers.fields_adps = function ($form) {
	var _parent = DS3;
	var $parentEl = _parent.$el;

	// Set ADP field values
	for (let i = 1; i < 5; i++) {
		let ADP = $form.find(`[name="additional_datapoint_${i}"]`);
		if (ADP.length > 0 && $parentEl[0].hasAttribute(`data-adp${i}`)) {
			ADP.val($parentEl.attr(`data-adp${i}`));
			if (helpers.shouldDebug("ds3"))
				console.log(`[DS3.FormHelpers] ADP${i}: ${ADP.val()}`);
		}
	}
};

DS3_FormHelpers.field_country = function ($form) {
	// Set country code for form
	let countryCode = thryvSettings.thryvCountry.slice(0, 2);
	$form.find('[name="country_code"]').val(countryCode);
};

DS3_FormHelpers.fields_profile = function ($form) {
	// Populate with session storage if blank
	let demoProfile =
		sessionStorage.getItem("demoProfile") !== null
			? JSON.parse(sessionStorage.getItem("demoProfile"))
			: false;
	if (demoProfile) {
		let $nameField = $form.find('input[name="full_name"]');
		let $companyField = $form.find('input[name="company"]');
		let $emailField = $form.find('input[name="email"]');
		let $phoneField = $form.find('input[name="phone_input_only"]');

		if ($nameField.val() === "") $nameField.val(demoProfile.name).focus();

		if ($companyField.val() === "")
			$companyField.val(demoProfile.company).focus();

		if ($emailField.val() === "") $emailField.val(demoProfile.email).focus();

		if ($phoneField.val() === "") $phoneField.val(demoProfile.phone).focus();
	}
};

DS3_FormHelpers.field_zip = function ($form) {
	$form
		.find('input[name="zip"]')
		.attr({
			pattern: "[0-9]{5}",
			maxlength: 5,
		})
		.on("keyup keydown input focus blur", function () {
			$(this).val(helpers.numOnly($(this).val()));
		});
};

DS3_FormHelpers.field_salesChannel = function ($form) {
	$form.find('select[name="sales_channel"]').change(function () {
		let currVal = $form.find('select[name="sales_channel"]').val();
		if (currVal !== "") $form.find('input[name="utm_medium"]').val(currVal);
		if (helpers.shouldDebug("ds3"))
			console.info(`[DS3.FormHelpers] utm_medium has changed to ${currVal}`);
	});
};

DS3_FormHelpers.field_requestedDemoType = function ($form) {
	const _this = this;
	const $nameField = $form.find('input[name="full_name"]');
	const $firstName = $form.find('input[name="firstname"]');
	const $lastName = $form.find('input[name="lastname"]');
	const $companyField = $form.find('input[name="company"]');
	const $emailField = $form.find('input[name="email"]');
	const $phoneField = $form.find('input[name="phone_input_only"]');
	const $optOutField = $form.find('input[name="smsoptout__c"]');
	const $franchisorField = $form.find('input[name="franchisor"]');
	const $consentField = _this.getConsentField($form);

	helpers.hsPrivacyConsentInit($form, "txt-optin", "thryv-sapphire", "demo");
	$form.find(".legal-consent-container").addClass("mt-3 mb-1");
	$form
		.find(".legal-consent-container")
		.closest("fieldset")
		.insertBefore(
			$form
				.find(".legal-consent-container")
				.closest("fieldset")
				.prev("fieldset"),
		);

	const $demoTypeInputs = $form.find('input[name="requested_demo_type"]');

	var _parent = DS3;
	var $parentEl = _parent.$el;
	if ($parentEl[0].hasAttribute("data-submit-text")) {
		$form
			.find('input[name="requested_demo_type"][value="demo_scheduled"]')
			.siblings("span")
			.text($parentEl[0].getAttribute("data-submit-text"));
	}

	const showPrivacyConsentError = function () {
		$consentField.addClass("invalid error");
		if ($consentField.closest(".input").next(".hs-error-msgs").length <= 0) {
			$consentField
				.closest(".input")
				.after(
					'<ul class="no-list hs-error-msgs inputs-list" role="alert"><li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li></ul>',
				);
		} else {
			$consentField
				.closest(".input")
				.next(".hs-error-msgs")
				.html(
					'<li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li>',
				);
		}
	};

	$consentField.change(function () {
		if ($(this).is(":checked")) {
			// $consentField.removeClass('invalid error');
			// $consentField.closest('.input').next('.hs-error-msgs').remove();
			$optOutField.val("false");
		} else {
			$optOutField.val("true");
			// showPrivacyConsentError();
		}
	});

	$demoTypeInputs.prop("checked", false);

	$demoTypeInputs.on("click", function (e) {
		const $requiredFields = $form.find(
			'.hs-input[required]:not([name="requested_demo_type"])',
		);
		const formHasErrors = () => {
			if ($franchisorField.length > 0) $franchisorField.focus();
			$requiredFields.focus();
			$phoneField.focus().blur();

			const hasErrors =
				$form
					.find(".hs-error-msg")
					.closest(".hs-form-field:not(.hs_requested_demo_type)").length > 0;

			const isAnyRequiredEmpty = !$requiredFields.val();

			const isConsentMissing = !$consentField.is(":checked");

			const isFranchisorMissing =
				$franchisorField.length <= 0 ? false : !$franchisorField.is(":checked");

			return (
				hasErrors ||
				isAnyRequiredEmpty ||
				isFranchisorMissing /*|| isConsentMissing*/
			);
		};

		const isRequiredEmpty = !$requiredFields.val();
		if ($(this).val() === "demo_now" && isRequiredEmpty) {
			_this.redirectToDemoVideo();
		} else if (formHasErrors()) {
			// console.log("DS3_FormHelpers.field_requestedDemoType: errors:", hasErrors, isAnyRequiredEmpty, isConsentMissing);
			e.preventDefault();
			$demoTypeInputs.prop("checked", false);

			// if (isConsentMissing)
			// {
			//   showPrivacyConsentError();
			// }

			// console.log("DS3_FormHelpers.field_requestedDemoType: form blocked due to validation issues");
		}
	});

	// console.log('DS3_FormHelpers.field_requestedDemoType:', $demoTypeInputs);

	var eventNames = "change";
	// var eventNames = 'change click'; // the form submit will trigger twice

	$demoTypeInputs.on(eventNames, function () {
		if (helpers.shouldDebug("ds3"))
			console.log(
				"[DS3.FormHelpers] field_requestedDemoType:",
				$demoTypeInputs,
			);

		const hasErrors = $form.find(".hs-error-msg").length > 0;
		const isChecked = $demoTypeInputs.is(":checked");

		var _parent = DS3;
		var $parentEl = _parent.$el;

		if (!hasErrors && isChecked) {
			const $requiredFields = $form.find(
				'.hs-input[required]:not([name="requested_demo_type"])',
			);
			const isRequiredEmpty = !$requiredFields.val();
			const demoVideoSelected =
				$form.find('input[name="requested_demo_type"]:checked').val() ===
				"demo_now";

			if (!demoVideoSelected || !isRequiredEmpty) {
				$phoneField.focus().blur();
			}

			setTimeout(function () {
				if (!isRequiredEmpty) {
					_this.submitForm($form);
				}
			}, 100);
		} else {
			$demoTypeInputs.prop("checked", false);
			if (helpers.shouldDebug("ds3"))
				console.info("[DS3.FormHelpers] form has validation errors");
		}
	});
};

DS3_FormHelpers.submitForm = function ($form) {
	const _this = this;
	var _parent = DS3;

	if (helpers.shouldDebug("ds3"))
		console.log("[DS3.FormHelpers] submitForm", _parent.count++);

	const $submitBtn = this.getSubmitBtn($form);
	$submitBtn.prop("disabled", false);
	$submitBtn.trigger("click");

	this.deactivateIntercom();
	this.saveDemoProfile($form);

	this.activatePlaceholderForm($form);
	this.showSuccessMessage($form);

	_parent.$el.find(".form-instructions").hide();
	$form.hide();

	const demoVideoSelected =
		$form.find('input[name="requested_demo_type"]:checked').val() ===
		"demo_now";
	if (demoVideoSelected) {
		_this.redirectToDemoVideo(true);
	}
};

DS3_FormHelpers.activatePlaceholderForm = function ($form) {
	var _parent = DS3;
	var $parentEl = _parent.$el;
	var $formCopy = $form;
	var $formSuccess = $parentEl.find("#lead-info-form-success .hs-form-copy");

	$formSuccess.html($formCopy.clone(true));

	if (helpers.shouldDebug("ds3"))
		console.log("[DS3.FormHelpers] activatePlaceholderForm", $formSuccess);
};

DS3_FormHelpers.showSuccessMessage = function ($form) {
	var _parent = DS3;
	var $parentEl = _parent.$el;
	var $formSuccess = $parentEl.find(
		"#lead-info-form-success .hs-form-success-message",
	);
	var $formHeading = $parentEl.find(".form-heading");

	$formSuccess.show();
	$formHeading.hide();
};

DS3_FormHelpers.saveDemoProfile = function ($form) {
	let name = $form.find('input[name="full_name"]').val();
	let company = $form.find('input[name="company"]').val();
	let email = $form.find('input[name="email"]').val();
	let phone = $form.find('input[name="phone_input_only"]').val();

	// Populate session storage
	sessionStorage.setItem(
		"demoProfile",
		JSON.stringify({
			name,
			company,
			email,
			phone,
		}),
	);
};

DS3_FormHelpers.deactivateIntercom = function () {
	if (typeof Intercom !== "function") {
		return;
	}

	Intercom("shutdown");
	$(".custom-intercom-launcher").removeClass("active");
};

DS3_FormHelpers.setHubspotContactId = function ($form) {
	// adding a delay because the contact id is not available right away when its a new email
	setTimeout(function () {
		$.ajax({
			type: "POST",
			url: thryvSettings.ajaxurl,
			data:
				"email=" +
				$form.find('input[name="email"]').val() +
				"&action=getHubspotID",
			success: function (response) {
				if (helpers.shouldDebug("ds3"))
					console.log("[DS3.FormHelpers] hubspot contact id:", response);
				if ("data" in response && response.data != "") {
					var hs_contact_info = JSON.parse(response.data);
					localStorage.setItem("thryv_lead", hs_contact_info.id);
					localStorage.setItem("thryv_lead_hubspot", hs_contact_info.id);
				}
			},
		});
	}, 500 * 8);
};

export default DS3_FormHelpers;
